import { render, staticRenderFns } from "./HomeSettingsComponent.vue?vue&type=template&id=1f8eb898&scoped=true&"
import script from "./HomeSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./HomeSettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeSettingsComponent.vue?vue&type=style&index=0&id=1f8eb898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8eb898",
  null
  
)

export default component.exports